// "HEPSİNİ TOPLA" için kaydedilmemiş form sayacı. Kayıt YALNIZCA
// useFormDraft içinden yapılır (Faz G altyapısı yeniden kullanılır, yeni
// kirlilik mantığı yazılmaz).
const kayitlar = new Set();

export const registerDirtyForm = (o) => {
  kayitlar.add(o);
  return () => kayitlar.delete(o);
};

export const kirliFormSayisi = () =>
  [...kayitlar].filter((o) => {
    try { return !!o.kirli?.(); } catch { return false; }
  }).length;

// Kirli formların içeriğini Faz G taslağı olarak yazar; yazılan sayıyı döner.
export const kirliTaslaklariYaz = () => {
  let n = 0;
  for (const o of kayitlar) {
    try {
      if (o.kirli?.() && o.yaz?.()) n += 1;
    } catch { /* yoksay */ }
  }
  return n;
};
